import { render, staticRenderFns } from "./QuestionRuleAllModal.vue?vue&type=template&id=0af4404e&"
import script from "./QuestionRuleAllModal.vue?vue&type=script&lang=js&"
export * from "./QuestionRuleAllModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports